/**
 * this component base on `My Profile` UI's role
 * @property role {object} role information object
 */
import React, {Component} from 'react';
import Tooltip from 'rc-tooltip';
import Done from 'material-ui/svg-icons/action/done';
import TipIcon from 'material-ui/svg-icons/action/info-outline';
import {buttonBlueColor} from '../../../utils/utility';

import './role-explain.css';
class RoleExplainTip extends Component {
  render () {
    return (
      <div className="role-explain clearfix">
        <strong>Role</strong>
        <span>{this.props.role.name}</span>
        <Tooltip
          placement="right"
          overlayClassName="profile-role-info"
          overlayStyle={{width:"36%"}}
          overlay={
            <div className="profile-overlay-container">
              <p>{this.props.role.name}</p>
              <ul>
                {
                  this.props.role.capabilities !== undefined && this.props.role.capabilities.map((item, index) => (
                    <li className="clearfix" key={index}>
                      <div className="icon" style={{background: buttonBlueColor()}}>
                        <Done
                          style={{width: '14px', height: '14px', color: 'white'}}
                        />
                      </div>
                      <section>
                        {item}
                      </section>
                    </li>
                  ))
                }

              </ul>
            </div>
          }
          arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
        >
          <TipIcon
            style={{color: 'black', width: '25px', height: '25px', marginTop: '3px', marginLeft: '10px', cursor: 'pointer'}}
          />
        </Tooltip>
      </div>
    )
  }
}
export default RoleExplainTip;


// WEBPACK FOOTER //
// ./src/components/framework/RoleExplainTip/RoleExplainTip.jsx